import { Query, QueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@app/constants/service';
import {
  MessageTemplate,
  MessageTemplateList,
} from '@app/types/message-template';

export const isJobTemplatesQuery =
  (jobId: string) =>
  (query: Query): boolean =>
    query.queryKey[0] === QUERY_KEYS.MESSAGE_TEMPLATES &&
    (query.queryKey[2] as { jobId?: string } | undefined)?.jobId === jobId;

export const invalidateTemplateRecommendations = (
  jobId: string | undefined,
  queryClient: QueryClient,
) => {
  if (!jobId || !queryClient) return;
  queryClient.invalidateQueries({
    queryKey: QUERY_KEYS.TEMPLATE_RECOMMENDATION(jobId),
  });
  queryClient.invalidateQueries({ predicate: isJobTemplatesQuery(jobId) });
};

export const clearTemplateRecommendations = (
  jobId: string | undefined,
  queryClient: QueryClient,
) => {
  if (!jobId || !queryClient) return;
  queryClient.setQueryData(QUERY_KEYS.TEMPLATE_RECOMMENDATION(jobId), null);
  queryClient.setQueriesData<{ pages: MessageTemplateList[] }>(
    { predicate: isJobTemplatesQuery(jobId) },
    (data) =>
      data && {
        ...data,
        pages: data.pages.map((page, index) =>
          index === 0
            ? {
                ...page,
                templates: (page.templates ?? []).filter(
                  (template: MessageTemplate) => !template.isRecommended,
                ),
                recommendedCount: 0,
              }
            : page,
        ),
      },
  );
};
